const config = {
  API: process.env.REACT_APP_API || 'https://dr0ntlinpl.execute-api.ap-northeast-1.amazonaws.com/Prod/api/code',
  EXPRESS_API: process.env.REACT_APP_EXPRESS_API || 'http://localhost:3004',
  COGNITO_REGION: process.env.REACT_APP_COGNITO_REGION || 'ap-northeast-1',
  COGNITO_USERPOOL: process.env.REACT_APP_COGNITO_USERPOOL || 'ap-northeast-1_ldmhOiaHQ',
  COGNITO_CLIENTID: process.env.REACT_APP_COGNITO_CLIENTID || '6viiigapi1589k8jae3ahfd3na',
};

// Can't set .env.local to be an empyt string
// https://github.com/facebook/create-react-app/issues/4002
if (process.env.REACT_APP_EXPRESS_API === 'undefined') {
  config.EXPRESS_API = '';
}

export default config;



// WEBPACK FOOTER //
// ./src/config.js